import { isNil, omitBy } from 'lodash-es';

import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v4/catalog/products/`;

export const QueryKey = (payload?: Payload) => ['v4', 'catalog', 'products', omitBy(payload, isNil)] as const;

export type Payload = {
    letter?: string;
    vendor?: string;
    year?: number;
    /** From 1 to 12 */
    month?: number;
    /** From 0 to 9 */
    score?: number;
    page?: number;
    size?: number;
    search?: string;
    sort?: {
        field: Omit<keyof Models.Catalog.Product.Item, 'vendor'>;
        direction: 'asc' | 'desc';
    };
};

export type Response = {
    total: number;
    items: Models.Catalog.Product.Item[];
};
